import { LoanDetails } from "./loan-details.model"

export interface LoanTransactionDetail {
  creditAmount: number
  debitAmount: number
  narration: string
  runningBalance: number
  transactionCategory: string
  transactionDate: string
  transactionRef: string
  valueDate: string
}


export interface LoanTranDetails extends LoanDetails{
  transactionDetails: LoanTransactionDetail[]
  flexPayTrxList?: []
}